import { create } from '../../feathersFunctionalWrapper';

const TT_DOCUMENTS_URL = import.meta.env.VITE_TURBOTENANT_DOCUMENTS_URL;

const isDraftDocumentUrl = (url) => url && url.includes('draft_documents');

const extractPath = (url) => {
  const match = url.match(/(uploads\/draft_documents\/[^?]+)/);
  return match ? match[1] : url;
};

let cachedToken = null;
let tokenExpiresAt = null;
let cachedOrganizationId = null;

const getUserToken = async (organizationId) => {
  if (cachedToken && Date.now() < tokenExpiresAt && cachedOrganizationId === organizationId) {
    return cachedToken;
  }

  const response = await create('turbotenant-document-token', { organizationId });
  cachedToken = response.token;
  cachedOrganizationId = organizationId;
  // Token is valid for 6 hours
  tokenExpiresAt = Date.now() + 6 * 60 * 60 * 1000;

  return cachedToken;
};

const openDocumentWithSignedUrl = async (rawUrl, organizationId) => {
  if (!isDraftDocumentUrl(rawUrl)) {
    window.open(rawUrl, '_blank', 'noopener,noreferrer');
    return;
  }

  const path = extractPath(rawUrl);
  const token = await getUserToken(organizationId);
  const documentUrl = `${TT_DOCUMENTS_URL}?path=${encodeURIComponent(path)}&token=${token}`;

  window.open(documentUrl, '_blank', 'noopener,noreferrer');
};

export default openDocumentWithSignedUrl;
